module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/WqbnGj/tc-custom/9781423631200.jpg?1707017810973",
      "alt": "This image is the cover for the book Pie Pops"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pie Pops\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Simple recipes for sweet and savory bites on a stick.")])]), _c('p', [_vm._v("From the frozen treats we look forward to during the hot days of summer to all-day suckers, hot dogs, and even cake, everything tastes better on a stick. So why not pie? Pie Pops are just that, mini pies on a stick that will appeal to both young and old alike. With simple recipes and ingredients that include sweet and savory fillings, people of all ages will appreciate this simple, portable way to enjoy traditional American classics such as: Apple, Razzleberry, Lemon Meringue, Chocoholic, and more. Easy-as-pie!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marcie Ballard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Marcie Ballard enjoys creating her own versions to add excitement and delish factors. With a desire to share her secrets on how to make these tasty treats, the best tip is: keep it simple. She has a desire for sharing with friends or family how she made the tasty treat and the secret she has learned is to keep it simple. Pie Pops is her first book. She lives in Utah.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0